/*
 * Purpose: About — version, release channel, proprietary notice
 * Last modified: 2026-06-28 | Agent
 * Completeness: 96
 */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { BUILD_INFO, RELEASE_CHANNEL, VERSION_DISPLAY } from '@/lib/appVersion';
import { COMPANY_FOOTER_LINE, COMPANY_INFO, COPYRIGHT_NOTICE } from '@/lib/companyInfo';

export function AboutVersionPanel() {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Version</CardTitle>
          <CardDescription>Current release of {COMPANY_INFO.productName}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-wrap items-center gap-2">
            <Badge variant="default" className="text-sm tabular-nums">
              {VERSION_DISPLAY}
            </Badge>
            <Badge variant="outline">{RELEASE_CHANNEL}</Badge>
          </div>
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div>
              <dt className="text-muted-foreground">Product</dt>
              <dd className="font-medium">{BUILD_INFO.product}</dd>
            </div>
            <div>
              <dt className="text-muted-foreground">Semver</dt>
              <dd className="font-medium tabular-nums">{BUILD_INFO.version}</dd>
            </div>
          </dl>
          <p className="text-xs text-muted-foreground">
            We use semantic versioning: patch = fixes, minor = features, major = breaking changes.
            Engineering details live in the repository{' '}
            <code className="text-[11px] bg-muted px-1 rounded">docs/16-versioning.md</code>.
          </p>
        </CardContent>
      </Card>

      <Card className="border-amber-500/25 bg-amber-500/5">
        <CardHeader>
          <CardTitle className="text-lg">Proprietary software</CardTitle>
          <CardDescription>Not open source — Teknoled-G intellectual property</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-muted-foreground">
          <p>{COPYRIGHT_NOTICE}</p>
          <p>{COMPANY_FOOTER_LINE}</p>
          <p>
            {COMPANY_INFO.productName} source code, documentation, branding, and automation flows are
            proprietary. No license is granted to copy, modify, distribute, or create derivative works
            except as expressly authorized in writing by {COMPANY_INFO.legalName}.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
